(function () {
  const container = document.querySelector('.shopify-policy__container');
  const body = document.querySelector('.shopify-policy__body');
  if (!container || !body || container.querySelector('[data-policy-navigation]')) return;

  const links = [
    ['Privacy policy', '/policies/privacy-policy'],
    ['Terms of service', '/policies/terms-of-service'],
    ['Refund policy', '/policies/refund-policy'],
    ['Shipping policy', '/policies/shipping-policy'],
  ];
  const currentPath = window.location.pathname.replace(/\/$/, '');
  const nav = document.createElement('nav');
  nav.className = 'rm-policy-switcher';
  nav.setAttribute('aria-label', 'Policies');
  nav.setAttribute('data-policy-navigation', '');
  nav.innerHTML = [
    '<p class="rm-policy-switcher__title">Policies</p>',
    '<ul class="rm-policy-switcher__list">',
    ...links.map(([label, href]) => {
      const active = currentPath === href;
      return [
        '<li class="rm-policy-switcher__item">',
        `<a class="rm-policy-switcher__link" href="${href}"${active ? ' aria-current="page"' : ''}>${label}</a>`,
        '</li>',
      ].join('');
    }),
    '</ul>',
  ].join('');
  body.insertAdjacentElement('afterend', nav);
})();
